export const lang = {
	//titleชื่อเรื่องสําหรับแต่ละหน้า
	title: 'หน้าแรกของร้านค้า',
}
